module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-11.1ce01921.png";